var plugin_rtlignore_default = {
  "alignLeft": "Rkk8A",
  "textWrapNowrap": "jPcd6",
  "alignRight": "JtVwH",
  "alignCenter": "ts54O",
  "sizeFullWidth": "Vo5Jq",
  "renderedInTable": "hS9BD",
  "sizeOriginal": "_3X9CU",
  "sizeContent": "AZ-Yq",
  "sizeSmall": "_4njo9",
  "sizeSmallCenter": "uK776",
  "flex": "HEAAb",
  "atomic": "_3wbUI",
  "embed": "uhg6f",
  "horizontalScrollbar": "HwlUX",
  "pluginContainerMobile": "_4UFg8"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
